import type { ChatUiMultiLeg, FlightMultiLegPicksContext } from '@voll-intelligence/genui-contract';
import type { Picks } from './flight_multi_offers.js';

/** O board no vocabulário do wire (`FlightMultiLegPicksContext.legs`): índices
 *  crescentes, só os trechos com pick. */
export function picksToWire(picks: Picks): FlightMultiLegPicksContext['legs'] {
  return Object.entries(picks)
    .map(([key, pick]) => ({ legIndex: Number(key), ...pick }))
    .sort((a, b) => a.legIndex - b.legIndex);
}

/** O passo em que o card ABRE: o primeiro sem pick (o `:f` com o trecho 1
 *  ecoado abre no 2); roteiro todo decidido abre no 1. */
export function firstPendingLeg(legs: ChatUiMultiLeg[], picks: Picks): number {
  const pending = legs.findIndex((_, i) => picks[i] === undefined);
  return pending >= 0 ? pending : 0;
}
